var map = {
	"./circle_black.svg": 1043,
	"./circle_blue.svg": 1044,
	"./ellipse_black.svg": 1045,
	"./france.svg": 312,
	"./highlighted_yellow.svg": 1046,
	"./icons/Cart.svg": 1047,
	"./icons/Cart_add.svg": 1048,
	"./icons/Cart_delete.svg": 321,
	"./icons/Cart_remove.svg": 322,
	"./icons/_info.svg": 1049,
	"./icons/add_prod.svg": 323,
	"./icons/add_prodOLD.svg": 1050,
	"./icons/ask.svg": 1051,
	"./icons/carousel.svg": 320,
	"./icons/facebook.svg": 27,
	"./icons/hatchef.svg": 65,
	"./icons/icone/_info.svg": 1052,
	"./icons/icone/book-open-solid.svg": 373,
	"./icons/icone/columns-solid.svg": 374,
	"./icons/icone/file-pdf-solid.svg": 376,
	"./icons/icone/hatchef.svg": 1053,
	"./icons/icone/info.svg": 1054,
	"./icons/icone/list-solid.svg": 378,
	"./icons/icone/magnifying-glass-solid.svg": 375,
	"./icons/icone/play.svg": 1055,
	"./icons/icone/plus.svg": 1056,
	"./icons/icone/share-square-solid.svg": 377,
	"./icons/icone/specs.svg": 1057,
	"./icons/icone/world.svg": 1058,
	"./icons/index-icon-bookmark.svg": 1059,
	"./icons/index-icon.svg": 1060,
	"./icons/info.svg": 66,
	"./icons/markers-SVG/ask.svg": 1061,
	"./icons/markers-SVG/info.svg": 1062,
	"./icons/markers-SVG/list.svg": 1063,
	"./icons/markers-SVG/recipe.svg": 1064,
	"./icons/markers-SVG/web.svg": 1065,
	"./icons/play.svg": 56,
	"./icons/play_ip.svg": 1066,
	"./icons/plus.svg": 64,
	"./icons/promo.svg": 68,
	"./icons/promo2.svg": 1067,
	"./icons/promo3.svg": 1068,
	"./icons/promo_10.svg": 1069,
	"./icons/promo_classic.svg": 1070,
	"./icons/remove_prod.svg": 324,
	"./icons/remove_prodOLD.svg": 1071,
	"./icons/shop_list.svg": 1072,
	"./icons/specs.svg": 60,
	"./icons/whatsapp.svg": 28,
	"./icons/world.svg": 40,
	"./logo_interattivo_free.svg": 1073,
	"./logo_volantinointerattivo_free.svg": 379
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1042;